import React from 'react';
import AdminLayout from './AdminLayout';
import LeadPipelineTab from '../../components/admin/LeadPipelineTab';

export default function AdminLeadPipelinePage() {
    return (
        <AdminLayout title="Lead Pipeline" description="Configure lead pipeline stages and settings">
            <LeadPipelineTab />
        </AdminLayout>
    );
}
